import firebase from "firebase";

const config = {
  apiKey: "AIzaSyBlYGWHBAwffCSoAf9x0cd9bjI0l64PExk",
  authDomain: "spirelab-dysarthria.firebaseapp.com",
  databaseURL: "https://spirelab-dysarthria.firebaseio.com",
  projectId: "spirelab-dysarthria",
  storageBucket: "spirelab-dysarthria.appspot.com",
  messagingSenderId: "1065498167509",
  appId: "1:1065498167509:web:54d90f8f26a26046f87a5c",
  measurementId: "G-S6B8SVJ092",
};

firebase.initializeApp(config);

export default firebase;
